import module from "../module";
import template from "./enum-picker.tmpl.html";

import { RISK as riskEnum } from "#/constants/index";

module.directive("riskPicker" /* @ngInject */, function() {
  return {
    restrict: "A",
    require: "ngModel",
    replace: true,
    scope: {
      model: "=ngModel"
    },
    template,
    priority: 100,
    controller: /*@ngInject */ function($scope) {
      $scope.enums = riskEnum;
    }
  };
});
